let interval = 1000;
let maxAttempts = 10;
let attempts = 0;
let intervalId = setInterval(function () {
  attempts++;
  let element = document.querySelector(".tee-preview-button");
  if (element) {
    console.log("Element found:", element);
    const preview = document.querySelectorAll(".tee-preview-button");
    preview.forEach((item) => {
      item.addEventListener("click", function () {
        const modal = document.querySelector(".tee-preview-popup");
        document.body.parentElement.appendChild(modal);
      });
    });
    clearInterval(intervalId);
  } else if (attempts >= maxAttempts) {
    console.log("Element not found within 10 seconds.");
    clearInterval(intervalId);
  }
}, interval);

// document.addEventListener("teeinblue-event-component-injected", function () {
//   const element = document.querySelectorAll(".main-product-block");
//   const insertAfterElement = document.querySelector(".tee-option--size");
//   element.forEach((item) => {
//     if (item.textContent.includes("Size Guide")) {
//       if (insertAfterElement) {
//         insertAfterElement.after(item);
//       }
//     }
//   });
// });


// const checkSizingChart = () => { 
//   var sizingChart = document.querySelector('.tib-size-chart .tib-size-chart-link');
//   var teeOptionTitle = document.querySelector('.tee-variants');
//   if(sizingChart && teeOptionTitle) { 
//     var existingClone = teeOptionTitle.querySelector('.tib-size-chart-link');
//     if(!existingClone) {
//       var sizingChartClone = sizingChart.cloneNode(true);
//       teeOptionTitle.appendChild(sizingChartClone);
//       sizingChartClone.addEventListener('click', function() { sizingChart.click() });
//     }
//   }
// }
// document.addEventListener('teeinblue-event-variant-changed', checkSizingChart);
// document.addEventListener('teeinblue-event-component-injected', () => {
//   const checkElementRendered = setInterval(() => {
//     if(document.querySelector('.tib-size-chart .tib-size-chart-link')) {
//       checkSizingChart();
//       clearInterval(checkElementRendered);
//     }
//   },1000)
//   document.querySelectorAll('.tee-available-products .tee-radio').forEach((radio) => {
//       radio.addEventListener('click', () => {
//          setTimeout(() => { checkSizingChart() },200)     
//       });
//   });
// })


// Auto-open the personalize form so shoppers see the fields without having
// to click the "Personalize" button first. The app renders the form
// collapsed (.tee-form-toggle, display:none) and the button only toggles it,
// so a programmatic click is all opening takes. Polls because the button's
// own click handler is attached by the app at its own pace; a click that
// lands too early does nothing, hence the cooldown-and-retry rather than a
// single shot. Only ever clicks while the form is hidden, and stops for
// good the first time it is seen open - so it can never close a form, and
// a shopper who collapses it later stays collapsed.
//
// Once the form is confirmed open the now-redundant button is hidden
// (2026-08-17 user request). Deliberately only on success: if the auto-open
// ever fails, the button stays as the shopper's way into the form.
(function () {
  var tries = 0;
  var cooldown = 0;
  var autoOpenTimer = setInterval(function () {
    tries++;
    if (tries > 40) { clearInterval(autoOpenTimer); return; }
    var btn = document.querySelector(".tee-btn--personalize");
    var wrap = document.querySelector(".tee-form-toggle");
    if (!btn || !wrap) return;
    if (getComputedStyle(wrap).display !== "none") {
      btn.style.display = "none";
      clearInterval(autoOpenTimer);
      return;
    }
    if (cooldown > 0) { cooldown--; return; }
    btn.click();
    cooldown = 4;
  }, 250);
})();

document.addEventListener('teeinblue-event-component-injected', function() {
    const checkElementRendered = setInterval(() => {
      const elementToMove = document.querySelector('.tib-size-chart .tib-size-chart-link');
      const insertAfterElement = document.querySelector('#teeFormInputs');
      if(elementToMove) {
        clearInterval(checkElementRendered);
        insertAfterElement.before(elementToMove)
      }
    },1000)
});
// 2026-08-17: on form-only pages (Shopify-created listings, marked by the
// collapsed .tee-form-toggle form) move the theme's quantity stepper above
// the app's PREVIEW button, so the order matches the layout-2 campaigns:
// fields -> quantity -> PREVIEW -> ADD TO CART. The move is safe because
// the quantity input is form-associated through its form="" attribute and
// submits with the product form from anywhere in the DOM. The app rebuilds
// parts of its form while editing, so a guardian re-inserts the stepper if
// a rebuild ever detaches it.
(function () {
  var moved = null;
  function anchorEl() {
    var wrap = document.querySelector(".tee-form-toggle");
    if (!wrap) return null;
    return wrap.querySelector(".tee-campaign-form-footer") || wrap.querySelector(".tee-form-action");
  }
  function place() {
    var anchor = anchorEl();
    var stepper = moved || document.querySelector(".product-form__buttons .product-form__quantity") || document.querySelector(".product-form__quantity");
    if (!anchor || !stepper) return false;
    if (stepper.nextElementSibling !== anchor || stepper.parentElement !== anchor.parentElement) {
      anchor.parentElement.insertBefore(stepper, anchor);
      stepper.classList.add("lh-qty-moved");
    }
    moved = stepper;
    return true;
  }
  var tries = 0;
  var t = setInterval(function () {
    tries++;
    if (place() || tries > 40) clearInterval(t);
  }, 250);
  document.addEventListener("teeinblue-event-component-injected", function () {
    setTimeout(place, 300);
  });
  setInterval(function () {
    if (moved && !document.contains(moved)) place();
  }, 800);
})();

/* ---------------------------------------------------------------------------
   Photo consent gate (2026-09-02)

   Shows a consent tick ONLY on campaigns that actually ask for a photo. A
   checkbox added in the customiser otherwise appears on every product,
   including ones with nothing to upload, where it reads as nonsense.

   The marker is teeinblue's own: a photo field renders as `.tee-field--photo`
   (with an input[type=file] id'd `tee-photo-layer-N`). Products without one -
   the Bloom By Birth mug, which has only text, font and clipart fields - never
   get the row.

   REMOVED AND RESTORED THE SAME DAY. It was deleted once, on a report of "a
   double checkbox". That second box was teeinblue's OWN
   "The personalization I entered is correct." control, which it renders on
   every campaign and which is NOT a consent control. Deleting this left the
   store with no photo consent at all. Hence `alreadyHandled()` below: if a
   real teeinblue consent field ever does get added, this row stands down by
   itself instead of being removed by hand on a mistaken read.

   Placement is BELOW the upload control, at the owner's instruction. That
   trades something worth knowing: teeinblue sends the file the moment it is
   chosen, so a shopper can upload before reaching this row, and the tick reads
   as after-the-fact confirmation rather than notice given before collection.
   What holds it up is that Add to Cart is gated on it, so nothing is ORDERED
   without the release. To put it back above, drop the two `.nextSibling`s.

   The listener is on the capture phase because teeinblue's Add to Cart is a
   plain <button type="button"> it drives from its own JS; a bubbling listener
   runs too late to stop it.

   NOT RECORDED AGAINST THE ORDER. teeinblue builds the cart payload itself, so
   nothing added here reliably reaches the line item. Storing the tick with the
   order still needs a teeinblue checkbox FIELD on each photo campaign.
   --------------------------------------------------------------------------- */
(function () {
  /* Singular and plural. A campaign asking for four photos must not take a
     release worded for one - the tick has to cover everything uploaded. */
  var TEXT_ONE  = 'I agree to my photo being used to create my personalized item, ' +
                  'and I confirm I have the right to use it, including the ' +
                  'permission of anyone shown in it.';
  var TEXT_MANY = 'I agree to my photos being used to create my personalized item, ' +
                  'and I confirm I have the right to use them, including the ' +
                  'permission of anyone shown in them.';
  /* PET photo products. Tag the product `pet-photo` and theme.liquid puts
     `lh-pet-photo` on <body>; the row then uses the pet sentence. Human photo
     products keep the sentence above.
     2026-09-17 (later, owner-approved): reworded photo-first. "I agree to my
     pet's photo being used" stacked a possessive on a passive and read oddly.
     These no longer open with "I agree" - that is fine, because
     alreadyHandled() skips this row by id and only reads OTHER checkboxes. */
  var PET_ONE  = 'This photo of my pet is mine to use, and I\'m happy for it ' +
                 'to be printed on my item.';
  var PET_MANY = 'These photos of my pets are mine to use, and I\'m happy for ' +
                 'them to be printed on my item.';
  function consentText(n) {
    if (document.body && document.body.classList.contains('lh-pet-photo')) {
      return n > 1 ? PET_MANY : PET_ONE;
    }
    return n > 1 ? TEXT_MANY : TEXT_ONE;
  }
  var LINK = 'https://www.lilachaven.com/policies/privacy-policy';
  var ID = 'lh-photo-consent';

  /* FINDING THE UPLOAD CONTROL - two lessons paid for on 2026-09-02.

     1. Do not test offsetParent. It was used here for one hour and broke the
        row on an unknown number of products. teeinblue renders its form
        COLLAPSED (.tee-form-toggle, display:none) and a separate script above
        clicks it open a moment later. Anything inside a display:none ancestor
        reports offsetParent null, so while the form was shut every upload
        control looked hidden and no row was ever built. Only this element's
        OWN display is checked now, which still catches a field teeinblue hides
        for a particular variant but is blind to the collapsed form around it.

     2. Do not rely on one class. `.tee-field--photo` is what the campaigns
        checked on 9/2 render, but the owner reports upload fields that this
        did not catch, so any tee field containing a file input counts too.
        Widening this is cheap; a missed upload means a photo collected with no
        consent, which is not. When in doubt this fails OPEN - it shows the
        tick - because a redundant tick is a smaller problem than a missing
        one. */
  /* Returns EVERY visible upload control, in document order. Campaigns can
     have several - "Upload Photo #1" through "#4" - and which one the row is
     anchored to changes what the shopper appears to be agreeing to. */
  function photoFields() {
    var seen = [];
    var i;
    var direct = document.querySelectorAll('.tee-field--photo');
    for (i = 0; i < direct.length; i++) seen.push(direct[i]);

    var files = document.querySelectorAll(
      'input[type="file"][id^="tee-photo-layer-"], .tee-field input[type="file"], .tee-photo input[type="file"]'
    );
    for (i = 0; i < files.length; i++) {
      var host = files[i].closest ? files[i].closest('.tee-field') : null;
      if (host && seen.indexOf(host) === -1) seen.push(host);
    }

    var visible = [];
    for (i = 0; i < seen.length; i++) {
      if (getComputedStyle(seen[i]).display !== 'none') visible.push(seen[i]);
    }
    if (visible.length) {
      /* Document order, so the LAST one is the bottom of the upload stack. */
      visible.sort(function (a, b) {
        return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
      });
      return visible;
    }

    /* MANUAL OVERRIDE, for when the detection above misses.
       Tag the product `photo-upload` in Shopify and theme.liquid puts
       `lh-photo-upload` on <body>. The row is then anchored to the last
       teeinblue field, or the form itself, and appears regardless of what
       markup the app happens to render for its uploader. This is the answer to
       "in future this will not be detectable automatically": the tag is yours,
       it does not move when teeinblue changes, and it costs one word per
       product. Detection stays the default so nothing needs tagging today. */
    if (document.body.classList.contains('lh-photo-upload')) {
      var fields = document.querySelectorAll('.tee-field');
      if (fields.length) return [fields[fields.length - 1]];
      var fb = document.querySelector('#teeFormInputs') ||
               document.querySelector('.tee-customization-form');
      return fb ? [fb] : [];
    }
    return [];
  }

  /* The anchor is the LAST upload control, never the first. A tick sitting
     under "Upload Photo #1" on a campaign that asks for four reads as consent
     for that one photo only (owner, 2026-09-02). Placed under the last one it
     follows the whole set, and the wording goes plural to match. */
  function photoField() {
    var f = photoFields();
    return f.length ? f[f.length - 1] : null;
  }
  function box() { return document.getElementById('lh-photo-consent-box'); }

  /* A genuine consent control added on the teeinblue side, which would make
     this row a duplicate. Matched on the wording, not on teeinblue's default
     "The personalization I entered is correct.", which is a different thing. */
  function alreadyHandled() {
    var boxes = document.querySelectorAll('.tee-field input[type="checkbox"], .tee-checkbox__input');
    for (var i = 0; i < boxes.length; i++) {
      if (boxes[i].id === 'lh-photo-consent-box') continue;
      var lbl = document.querySelector('label[for="' + boxes[i].id + '"]');
      var txt = ((lbl && lbl.textContent) || '').toLowerCase();
      if (/i agree|right to use|permission of anyone/.test(txt)) return true;
    }
    return false;
  }

  function build() {
    var fields = photoFields();
    var pf = fields.length ? fields[fields.length - 1] : null;
    var existing = document.getElementById(ID);

    if (!pf || alreadyHandled()) { if (existing) existing.remove(); return; }
    if (existing) {
      /* Re-anchor if teeinblue rebuilt the form, and re-word if the number of
         upload controls changed (a variant can add or drop one). */
      if (existing.previousElementSibling !== pf) pf.parentNode.insertBefore(existing, pf.nextSibling);
      if (existing.getAttribute('data-n') !== String(fields.length)) {
        existing.setAttribute('data-n', String(fields.length));
        var span = existing.querySelector('.lh-consent__text');
        var a = span.querySelector('a');
        span.textContent = consentText(fields.length) + ' ';
        if (a) span.appendChild(a);
      }
      return;
    }

    var row = document.createElement('div');
    row.id = ID;
    row.className = 'lh-consent';
    row.setAttribute('data-n', String(fields.length));
    row.innerHTML =
      '<label class="lh-consent__label" for="lh-photo-consent-box">' +
        '<input type="checkbox" id="lh-photo-consent-box" class="lh-consent__box">' +
        '<span class="lh-consent__text">' + consentText(fields.length) +
          ' <a href="' + LINK + '" target="_blank" rel="noopener">How we handle photos</a>' +
        '</span>' +
      '</label>' +
      '<p class="lh-consent__warn" hidden>Please tick the box above before adding this to your cart.</p>';
    pf.parentNode.insertBefore(row, pf.nextSibling);

    row.addEventListener('change', function () {
      row.classList.remove('lh-consent--miss');
      row.querySelector('.lh-consent__warn').hidden = true;
    });
  }

  document.addEventListener('click', function (e) {
    if (!photoField()) return;
    if (!e.target.closest) return;
    var btn = e.target.closest('.tee-btn--atc, .product_submit_button, button[name="add"]');
    if (!btn) return;
    var b = box();
    if (!b || b.checked) return;

    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var row = document.getElementById(ID);
    if (row) {
      row.classList.add('lh-consent--miss');
      row.querySelector('.lh-consent__warn').hidden = false;
      row.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);

  function start() {
    build();
    /* attributes matter as much as childList here: the form is opened by a
       style change, not by nodes appearing, so a childList-only observer never
       re-ran build() once the form unfolded. That, together with the
       offsetParent test above, is what hid the row on some products. */
    new MutationObserver(build).observe(document.documentElement, {
      childList: true, subtree: true,
      attributes: true, attributeFilter: ['style', 'class']
    });

    /* teeinblue's own lifecycle events, and a short backstop poll for the
       stretch before the app has finished injecting anything at all. */
    document.addEventListener('teeinblue-event-component-injected', build);
    document.addEventListener('teeinblue-event-variant-changed', build);
    var n = 0;
    var t = setInterval(function () { build(); if (++n > 40) clearInterval(t); }, 250);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------------------
   "How we handle photos" mini popup (2026-09-02)

   ALL WIDTHS (phones too since 2026-10-17, owner: the full policy opened on
   a phone and the photo part was buried at the bottom). The link in the
   consent row opens a small panel with ONLY the photo section, plus a "Read
   the full privacy policy" link. On desktop it is pinned to the width of the
   consent text; on a phone the CSS caps it at the screen width. With
   JavaScript off the anchor's own target="_blank" still opens the policy.

   Wording is lifted from the live privacy policy's "Photos You Upload for
   Personalization" and "How Long We Keep Photos" sections. If the policy
   changes, change this too - a summary that contradicts the policy is worse
   than no summary.
   --------------------------------------------------------------------------- */
(function () {
  var PANEL_ID = 'lh-photo-modal';
  var POLICY = 'https://www.lilachaven.com/policies/privacy-policy';

  var BODY =
    '<h2 class="lh-pm__title">How we handle your photo</h2>' +
    '<dl class="lh-pm__list">' +
      '<dt>What we collect</dt>' +
      '<dd>The image you upload, and anything you type alongside it.</dd>' +
      '<dt>Why we use it</dt>' +
      '<dd>Only to create, preview and print the item you ordered, to re-print or refund it if something goes wrong, and to deal with any dispute about the order.</dd>' +
      '<dt>Who else sees it</dt>' +
      '<dd>An outside artificial-intelligence image service acting for us, and the partner who prints your item.</dd>' +
      '<dt>Training</dt>' +
      '<dd>We never use your photo to train artificial-intelligence models, and we require our providers not to train on it either.</dd>' +
      '<dt>Identifying people</dt>' +
      '<dd>We never create or store a faceprint or any other biometric identifier, and we never use your photo to identify anyone.</dd>' +
      '<dt>How long we keep it</dt>' +
      '<dd><ul>' +
        '<li>While your order is being made and shipped.</li>' +
        '<li>Permanently deleted ninety days after delivery.</li>' +
        '<li>Permanently deleted within thirty days if you never complete the order.</li>' +
        '<li>Never longer than one year after your last interaction with us.</li>' +
        '<li>Sooner if you ask — within thirty days, and straight away if your item has not been made yet.</li>' +
      '</ul></dd>' +
    '</dl>' +
    '<p class="lh-pm__note">Please only upload a photo you have the right to use. If it shows someone other than you, make sure they are happy for it to be used this way.</p>' +
    '<p class="lh-pm__more"><a href="' + POLICY + '" target="_blank" rel="noopener">Read the full privacy policy</a></p>';

  var lastFocus = null;

  function close() {
    var p = document.getElementById(PANEL_ID);
    if (p) p.remove();
    document.removeEventListener('keydown', onKey, true);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) { if (e.key === 'Escape' || e.keyCode === 27) { e.stopPropagation(); close(); } }

  function open(anchor) {
    close();
    var row = anchor.closest('.lh-consent');
    var wrap = document.createElement('div');
    wrap.id = PANEL_ID;
    wrap.className = 'lh-pm';
    wrap.innerHTML =
      '<div class="lh-pm__scrim" data-close="1"></div>' +
      '<div class="lh-pm__panel" role="dialog" aria-modal="true" aria-label="How we handle your photo">' +
        '<button type="button" class="lh-pm__x" aria-label="Close" data-close="1">&times;</button>' +
        '<div class="lh-pm__body">' + BODY + '</div>' +
      '</div>';
    document.body.appendChild(wrap);

    /* Pinned to the consent text's own width - the point of the exercise. */
    if (row) {
      var w = Math.round(row.getBoundingClientRect().width);
      if (w > 0) wrap.style.setProperty('--lh-pm-w', w + 'px');
    }

    wrap.addEventListener('click', function (e) {
      if (e.target.getAttribute && e.target.getAttribute('data-close')) close();
    });
    document.addEventListener('keydown', onKey, true);
    var x = wrap.querySelector('.lh-pm__x');
    if (x) x.focus();
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var a = e.target.closest('.lh-consent .lh-consent__text a');
    if (!a) return;
    e.preventDefault();
    lastFocus = a;
    open(a);
  });
})();
